<template>
    <card-seplag titulo="Habilidade/Experiência Profissional" class="p-col-12">
        <div class="p-col-12 avisos">
            <ul>
                <li>
                    <p><strong>Servidor, inclua as habilidades e experiências referentes aos idiomas, sistemas corporativos e atividades que você desempenhou ao longo da sua carreira profissional.</strong></p>
                </li>
            </ul>
        </div>
        <card-seplag header="Adicionar experiência profissional" class="p-col-12" v-if="exibirNovaExperiencia">
            <div class="p-grid p-fluid p-col-12">
                <!-- <pre>{{exp}}</pre> -->
                <Rotulo nome="Quais habilidades/experiências profissionais você possui?" cols="12 6 4 ">
                    <Dropdown :options="experiencias" v-model="exp.experiencia" optionLabel="descExperiencia"
                        @change="subNivel" @input="subNivel" />
                </Rotulo>
                <Rotulo nome="Subatividade/experiência:" v-if="exp.experiencia != null" cols="12 6 4 ">
                    <Dropdown :options="subExperiencias" v-model="exp.subExperiencia" optionLabel="descExperiencia" />
                </Rotulo>
                <Rotulo nome="Nível:" v-if="exp.subExperiencia != null && experienciaAux != 'ATIVIDADE'" cols="12 4 4 ">
                    <Dropdown :options="nivelExperiencia" v-model="exp.escalaExperiencia"
                        optionLabel="descExperiencia" />
                </Rotulo>
                <Rotulo nome="Período:" cols="12 4 4 " v-if="experienciaAux == 'ATIVIDADE'">
                    <Dropdown :options="periodoExperiencia" v-model="exp.escalaExperiencia"
                        optionLabel="descExperiencia" />
                </Rotulo>
                <Rotulo nome="Descreva a atividade/função:" cols="12 12 12"
                    v-if="experienciaAux == 'ATIVIDADE' || experienciaAux == 'OUTRA'">
                    <Textarea rows="4" v-model="exp.descExperienciaCicloPessoa"
                        @keyup="contaCaracter(exp.descExperienciaCicloPessoa)" />
                    <span>Quantidade de caracteres restantes: {{ totalCaracter }}</span>
                </Rotulo>
                <!-- <pre>{{exp}}</pre> -->
            </div>
            <div class="p-grid p-fluid p-col-12">
                <Rotulo cols="12 8 8 " v-if="!flagEditar" />
                <Rotulo cols="12 4 8 " v-if="flagEditar" />
                <Rotulo cols="12 4 2 " v-if="flagEditar">
                    <Button class="p-button-danger" label="Cancelar Edição" @click="fecharEditarExperiencia()"
                        icon="pi pi-times" iconPos="left" style="margim-right:0" />
                </Rotulo>
                <Rotulo cols="12 4 2 " v-if="flagEditar">
                    <Button label="Salvar Edição" @click="salvarEdicaoExperiencia()" icon="pi pi-pencil" iconPos="left"
                        style="margim-right:0" />
                </Rotulo>
                <Rotulo cols="12 4 2 " v-if="!flagEditar">
                    <Button class="p-button-success" label="Incluir" @click="salvarExperiencia()" icon="pi pi-plus"
                        iconPos="left"  />
                </Rotulo>
                <Rotulo cols="12 4 2 " v-if="!flagEditar">
                    <Button class="p-button-danger" label="Cancelar" @click="fecharEditarExperiencia()"
                        icon="pi pi-times" iconPos="left" style="margim-right:0" />
                </Rotulo>
            </div>
        </card-seplag>
        <Rotulo nome="" class="p-col-12">
        </Rotulo>
        <card-seplag titulo="Habilidades/Experiências profissionais cadastradas" class="p-col-12 ajusteSecao">
            <div class="p-col-12 ajusteSecao">
            <div class="p-col-12 ajustePanel" v-if="experienciasAtivas && experienciasAtivas.length > 0">
                <button  v-for="(experiencia, index) in experienciasAtivas" :key="experiencia.idenExperienciaCicloPessoa" type="button" @click="funcaoAccord(index)" class="p-col-12 ajustePanel">
                <Panel :toggleable="true" :collapsed="controlePanel[index]" class="p-col-12 ajustePanel"  >
                    <template slot="header">
                        <span class="acordion">{{colapseTeste}}</span>
                        <span>{{index + 1 + ' - ' + experiencia.experiencia.descExperiencia }}</span>
                        <span class="acordion">{{isCollapsed}}</span>
                    </template>
                    <div class="p-grid p-fluid ">
                        <div class="p-col-12 ajusteContent">
                            <label><strong>Subatividade/experiência em:
                                </strong>{{ experiencia.subExperiencia.descExperiencia }}</label>
                        </div>
                        <div class="p-col-12 ajusteContent">
                            <label><strong>Escala de habilidade: </strong>
                                {{ experiencia.escalaExperiencia.descExperiencia }}</label>
                        </div>
                        <div class="p-col-12 ajusteContent"
                            v-if="experiencia.experiencia.descExperiencia == 'OUTRA' || experiencia.experiencia.descExperiencia == 'ATIVIDADE/FUNÇÃO'">
                            <label><strong>Descrição da habilidades: </strong>
                                {{ experiencia.descExperienciaCicloPessoa }}</label>
                        </div>
                        <div class="p-col-12 p-md-4">
                            <Button label="Editar" icon="pi pi-pencil" @click="editarExperiencia(experiencia, index)"
                                class="p-button-success" />
                        </div>
                        <div class="p-col-12 p-md-4">
                            <Button label="Excluir" icon="pi pi-trash" @click="excluirExperiencia(experiencia)"
                                class="p-button-danger" />
                        </div>
                    </div>
                </Panel>
                </button>
            </div>
            <span v-else><i>Nenhum registro encontrado</i></span>
            <div class="p-col-12 p-md-3 p-md-offset-9" v-if="!exibirNovaExperiencia">
                <Button class="p-button-info" label="Cadastrar nova Habilidade/Experiência Profissional" @click="exibirNovaExperiencia = true"
                 icon="pi pi-save" iconPos="left" style="margim-right:0" />
        </div>
        </div>
        </card-seplag>

        <div class="p-col-12">
            <div class="p-grid">
                <div class="p-col-12 p-md-2 p-md-offset-3">
                    <Button label="Voltar" @click="prevPage()" icon="pi pi-angle-left" />
                </div>
                <div class="p-col-12 p-md-2">
                    <Button label="Finalizar Etapa" @click="concluirEtapa()" icon="pi pi-check"
                        class="p-button-success" />
                </div>
                <div class="p-col-12 p-md-2">
                    <Button label="Próximo" @click="nextPage()" icon="pi pi-angle-right" iconPos="right" />
                </div>
            </div>
        </div>
    </card-seplag>

</template>

<script>

import CardSeplag from '@/template/CardSeplag.vue'
import Rotulo from '@/template/RotuloSeplag.vue'
import { simNao } from '@/config/global'
import { baseApiUrl } from '@/config/global'
import { printToast } from '../../config/global'


const getDefaultState = () => {
    return {
        idenExperienciaCicloPessoa: null,
        experiencia: null,
        subExperiencia: null,
        escalaExperiencia: null,
        descExperienciaCicloPessoa: '',
        status: 'ATIVO'
    }
}

export default {
    name: "experiencia-profissional",
    components: { CardSeplag, Rotulo, },
    data: function () {
        return {
            tiposExperiencia: [
                { codgTipoExperiencia: 1, descTipoExperiencia: 'Serviço Público no Estado de Mato Grosso' },
                { codgTipoExperiencia: 2, descTipoExperiencia: 'Fora do Serviço Público no Estado de Mato Grosso' }
            ],
            simNao: simNao,
            areasConhecimento: [],
            orgaos: [],
            setores: [],
            experienciasServPublico: [],
            experienciasForaServPublico: [],
            colunasExperienciasForaServPublico: [

                { nome: 'nomeEmpresaOrgao', titulo: 'Empresa' },
                { nome: 'tempo', titulo: 'Tempo' },
                { nome: 'areaConhecimento.descAreaConhecimento', titulo: 'Área de Conhecimento' },
                { nome: 'descExperienciaForaMt', titulo: 'Experiência' }
            ],
            dadosPessoa: this.$store.getters.getDadosPessoa,
            registro: getDefaultState(),
            flagEditar: false,
            totalCaracter: 500,
            controleAccord: [],
            experiencias: null,
            experienciaAux: null,
            subExperiencias: null,
            nivelExperiencia: null,
            periodoExperiencia: null,
            experienciasAtivas: [],
            nomeExperiencia: null,
            exp: {
                cicloPessoa: {
                    idenCicloPessoa: this.$store.getters.getCicloPessoa[0].idenCicloPessoa,
                },
                experiencia: null,
                subExperiencia: null,
                escalaExperiencia: null,
                descExperienciaCicloPessoa: '',
                status: 'ATIVO'
            },
            idenExperienciaCicloPessoa: null,
            isCollapsed:false,
            colapseTeste:[],
            controlePanel:[],
            exibirNovaExperiencia: false
        }
    },
    methods: {
        carregarDados() {
            //listar experiencias
            this.$http.get(`${baseApiUrl}/experienciaprof/experiencias`).then(res => {
                this.experiencias = res.data
            })
            //listar experiencias ativas 
            this.$http.get(`${baseApiUrl}/experienciaprofcp/ciclopessoa/${this.exp.cicloPessoa.idenCicloPessoa}`).then(res => {
                this.experienciasAtivas = res.data
                for (let i = 0; i < this.experienciasAtivas.length; i++) {
                    this.controlePanel[i] = true
                    this.colapseTeste[i] = false
                }
            })

        },
        subNivel() {
            this.experienciaAux = null
            this.subExperiencias = null
            if (this.exp.experiencia.descExperiencia == "ATIVIDADE/FUNÇÃO") {
                this.experienciaAux = 'ATIVIDADE'
                this.$http.get(`${baseApiUrl}/experienciaprof/experiencias/subniveis/${this.exp.experiencia.idenExperiencia}`).then(res => {
                    this.subExperiencias = res.data.filter(item => item.codgNivel == 2)
                    this.periodoExperiencia = res.data.filter(item => item.codgNivel == 3)
                })
            } else if (this.exp.experiencia.descExperiencia == "OUTRA") {
                this.experienciaAux = 'OUTRA'
                this.$http.get(`${baseApiUrl}/experienciaprof/experiencias/subniveis/${this.exp.experiencia.idenExperiencia}`).then(res => {
                    this.subExperiencias = res.data.filter(item => item.codgNivel == 2)
                    this.nivelExperiencia = res.data.filter(item => item.codgNivel == 3)
                })
            } else {
                this.$http.get(`${baseApiUrl}/experienciaprof/experiencias/subniveis/${this.exp.experiencia.idenExperiencia}`).then(res => {
                    this.subExperiencias = res.data.filter(item => item.codgNivel == 2)
                    this.nivelExperiencia = res.data.filter(item => item.codgNivel == 3)
                })
            }
        },
        fecharEditarExperiencia() {
            this.exp.experiencia = null
            this.exp.subExperiencia = null
            this.exp.escalaExperiencia = null
            this.exp.descExperienciaCicloPessoa = null
            this.idenExperienciaCicloPessoa = null
            this.flagEditar = false
            this.experienciaAux = null
            this.exibirNovaExperiencia = false

        },
        editarExperiencia(dadosExperiencia, index) {
            this.exibirNovaExperiencia = true
            window.scrollTo(0, 0)
            this.exp.experiencia = dadosExperiencia.experiencia
            this.controlePanel[index] = false
            this.flagEditar = true
            if (this.exp.experiencia.descExperiencia == "ATIVIDADE/FUNÇÃO") {
                this.experienciaAux = 'ATIVIDADE'
                this.$http.get(`${baseApiUrl}/experienciaprof/experiencias/subniveis/${this.exp.experiencia.idenExperiencia}`).then(res => {
                    this.subExperiencias = res.data.filter(item => item.codgNivel == 2)
                    this.periodoExperiencia = res.data.filter(item => item.codgNivel == 3)
                })
            } else if (this.exp.experiencia.descExperiencia == "OUTRA") {
                this.experienciaAux = 'OUTRA'
                this.$http.get(`${baseApiUrl}/experienciaprof/experiencias/subniveis/${this.exp.experiencia.idenExperiencia}`).then(res => {
                    this.subExperiencias = res.data.filter(item => item.codgNivel == 2)
                    this.nivelExperiencia = res.data.filter(item => item.codgNivel == 3)
                })
            } else {
                this.$http.get(`${baseApiUrl}/experienciaprof/experiencias/subniveis/${this.exp.experiencia.idenExperiencia}`).then(res => {
                    this.subExperiencias = res.data.filter(item => item.codgNivel == 2)
                    this.nivelExperiencia = res.data.filter(item => item.codgNivel == 3)
                })
            }
            this.exp.subExperiencia = dadosExperiencia.subExperiencia
            this.exp.escalaExperiencia = dadosExperiencia.escalaExperiencia
            this.exp.descExperienciaCicloPessoa = dadosExperiencia.descExperienciaCicloPessoa
            this.idenExperienciaCicloPessoa = dadosExperiencia.idenExperienciaCicloPessoa
        },
        salvarEdicaoExperiencia() {
            let body = {
                cicloPessoa: this.exp.cicloPessoa,
                // idenExperienciaCicloPessoa:this.idenExperienciaCicloPessoa,
                experiencia: this.exp.experiencia,
                subExperiencia: this.exp.subExperiencia,
                escalaExperiencia: this.exp.escalaExperiencia,
                descExperienciaCicloPessoa: this.exp.descExperienciaCicloPessoa,
                // idenExperienciaCicloPessoa: this.idenExperienciaCicloPessoa,
                status: this.exp.status,

            }
            this.$http.put(`${baseApiUrl}/experienciaprofcp/${this.idenExperienciaCicloPessoa}`, JSON.stringify(body)).then(() => {
                this.fecharEditarExperiencia()
                this.$http.get(`${baseApiUrl}/experienciaprofcp/ciclopessoa/${this.exp.cicloPessoa.idenCicloPessoa}`).then(res => {
                this.experienciasAtivas = res.data
                for (let i = 0; i < this.experienciasAtivas.length; i++) {
                    this.controlePanel[i] = true
                    this.colapseTeste[i] = false
                }
                this.exibirNovaExperiencia = false
                    this.$toast.add({ severity: 'success', summary: 'Experiência profissional salva com sucesso', life: 10000 })
            })
                

            })
            //     this.$http.get(`${baseApiUrl}/experienciaprofcp/ativos`).then(res => {
            //         this.experienciasAtivas = res.data
            //         this.fecharEditarExperiencia()
            // })

        },
        async salvarExperiencia() {
            let body = this.exp
            let response = await this.$http.post(`${baseApiUrl}/experienciaprofcp`, JSON.stringify(body))
            if (response.status == 200) {
                printToast({ severity: 'success', summary: 'Ação efetuada', detail: "Experiência incluida com sucesso", life: 3000 })
            }
            this.$http.get(`${baseApiUrl}/experienciaprofcp/ciclopessoa/${this.exp.cicloPessoa.idenCicloPessoa}`).then(res => {
                this.experienciasAtivas = res.data
                for (let i = 0; i < this.experienciasAtivas.length; i++) {
                    this.controlePanel[i] = true
                    this.colapseTeste[i] = false
                }
                this.exibirNovaExperiencia = false
                    this.$toast.add({ severity: 'success', summary: 'Experiência profissional salva com sucesso', life: 10000 })
            })

            this.exp.experiencia = null
            this.exp.subExperiencia = null
            this.exp.escalaExperiencia = null
        },
        async excluirExperiencia(dadosExperiencia) {
            let response = await this.$http.delete(`${baseApiUrl}/experienciaprofcp/${dadosExperiencia.idenExperienciaCicloPessoa}`,)
            if (response.status == 200) {
                printToast({ severity: 'success', summary: 'Ação efetuada', detail: "Experiência excluída com sucesso", life: 3000 })
                this.$http.get(`${baseApiUrl}/experienciaprofcp/ciclopessoa/${this.exp.cicloPessoa.idenCicloPessoa}`).then(res => {
                this.experienciasAtivas = res.data
                for (let i = 0; i < this.experienciasAtivas.length; i++) {
                    this.controlePanel[i] = true
                    this.colapseTeste[i] = false
                }
                    
                })
            } else {
                printToast({ severity: 'error', summary: 'Ação não foi efetuada', detail: "Experiência não pode ser excluída", life: 3000 })
            }
        },
        fechaTodosAccord() {
            for (let i = 0; i < this.experienciasAtivas.length; i++) {
                this.controlePanel[i] = false
            }

        },
        contaCaracter() {
            if (this.exp.descExperienciaCicloPessoa == 1) {
                let contador = 500 - this.exp.descExperienciaCicloPessoa.length
                if (contador < 0) {
                    this.totalCaracter = 0
                    this.exp.descExperienciaCicloPessoa = this.exp.descExperienciaCicloPessoa.substring(0, 500)
                    this.$toast.add({ severity: 'error', summary: 'Erro no campo descrição ou experiência', detail: "Limite máximo de caracter alcançado", life: 5000 });
                } else {
                    this.totalCaracter = contador
                }
            } else {
                let contador = 500 - this.exp.descExperienciaCicloPessoa.length
                if (contador < 0) {
                    this.totalCaracter = 0
                    this.exp.descExperienciaCicloPessoa = this.exp.descExperienciaCicloPessoa.substring(0, 500)
                    this.$toast.add({ severity: 'error', summary: 'Erro no campo descrição ou experiência', detail: "Limite máximo de caracter alcançado", life: 5000 });
                } else {
                    this.totalCaracter = contador
                }
            }
        },
        concluirEtapa() {
            if (this.$store.getters.getDadosPessoa) {
                this.$http.put(`${baseApiUrl}/experienciaprofcp/concluir/${this.$store.getters.getDadosPessoa.idenCicloPessoa}`).then(res => {
                    this.$http
              .get(
                `${baseApiUrl}/ciclopessoafases/ciclopessoa/${this.$store.getters.getCicloPessoa[0].idenCicloPessoa}`
              )
              .then((res2) => {
                let flag =
                  this.$store.getters.getDadosPessoa.pessoa.flagServidor != 'S'
                let etapaCliclo = res2.data.filter(function (etapa) {
                  if (
                    etapa.fase.statFase != 'INATIVO' &&
                    etapa.fase.descFase != 'TERMO_ACEITE'
                  ) {
                    if (etapa.fase.descFase == 'VINCULOS' && flag) {
                      return false
                    } else {
                      return true
                    }
                  } else {
                    return false
                  }
                })
                this.$store.commit(
                  'setEtapasCiclo',
                  JSON.stringify(etapaCliclo)
                )
                this.$toast.add({
                  severity: 'success',
                  summary: res.data,
                  life: 3000,
                })
                this.$http
                  .get(
                    `${baseApiUrl}/ciclopessoas/resumo/${this.$store.getters.getIdenPessoa}`
                  )
                  .then((res3) => {
                    this.$store.commit(
                      'setCicloPessoa',
                      JSON.stringify(res3.data)
                    )
                    if (
                      this.$store.getters.getCicloPessoa.length > 0 &&
                      this.$store.getters.getCicloPessoa[0].vinculosAtivos
                        .length > 0 &&
                      this.$store.getters.getCicloPessoa[0].vinculosAtivos[0]
                        .numrProtocolo
                    ) {
                      this.$router.push({ name: 'recadastramento' })
                    } else {
                        this.$router.push({ name: 'RECAD_DEPENDENTES_VIEW' })
                    }
                  })
              })
              this.$router.push({ name: 'RECAD_DEPENDENTES_VIEW' })
          })
                this.$router.push({ name: 'RECAD_DEPENDENTES_VIEW' })
            } else {
                this.$router.push({ name: "recadastramento" })
            }
        },
        nextPage() {
            this.$router.push({ name: 'RECAD_DEPENDENTES_VIEW' })
        },
        prevPage() {
            this.$router.push({ name: 'RECAD_CAPACITACAO_VIEW' })
        },
        funcaoAccord(index) {
            this.controlePanel[index] = this.isCollapsed
            this.isCollapsed = !this.isCollapsed 
            this.controlePanel[index] =  this.colapseTeste[index] 
            this.colapseTeste[index] = !this.colapseTeste[index]
        },

    },
    mounted() {
        this.carregarDados()
    }
}
</script>
<style scoped>
.ajusteSecao{
    margin-top: 20px;
}
.ajustaBotao {
    /* justify-items: ; */
    justify-content: space-between;
    margin-top: 20px;
}
.ajustePanel{
    margin-top:-15px;
}
.ajusteContent{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start !important;
    justify-items: flex-start;
    margin-right: 1500px;
}
.acordion{
    display: none;
}
</style>
